import React from "react";



// react-bootstrap components
import {
    Badge,
    Button,
    Card,
    Form,
    InputGroup,
    Navbar,
    Nav,
    OverlayTrigger,
    Table,
    Tooltip,
    Container,
    Row,
    Col
} from "react-bootstrap";
import TotalEnrollInsights from "./TotalEnrolInsights";
import InsightPie from "./InsightPie";

function InsightCharts() {
    return (
        <>
            <Row>
                {/* <Col lg="4" sm="6">
                    <InsightPie/>
                </Col> */}
                <Col lg="12" sm="6">
                    <TotalEnrollInsights />
                </Col>

            </Row>
        </>
    );
}

export default InsightCharts;
